/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { NewDailyRate } from './';
import {
    NewDailyRateFromJSON,
    NewDailyRateFromJSONTyped,
    NewDailyRateToJSON,
} from './';
import type { UpdatedField } from './';
import {
    UpdatedFieldFromJSON,
    UpdatedFieldFromJSONTyped,
    UpdatedFieldToJSON,
} from './';
import type { UpdatedFieldName } from './';
import {
    UpdatedFieldNameFromJSON,
    UpdatedFieldNameFromJSONTyped,
    UpdatedFieldNameToJSON,
} from './';

/**
 * 
 * @export
 * @interface DailyRateField
 */
export interface DailyRateField extends UpdatedField {
    /**
     * 
     * @type {NewDailyRate}
     * @memberof DailyRateField
     */
    dailyRate: NewDailyRate;
}

/**
 * Check if a given object implements the DailyRateField interface.
 */
export function instanceOfDailyRateField(value: object): value is DailyRateField {
    if (!('dailyRate' in value) || value['dailyRate'] === undefined) return false;
    return true;
}

export function DailyRateFieldFromJSON(json: any): DailyRateField {
    return DailyRateFieldFromJSONTyped(json, false);
}

export function DailyRateFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyRateField {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldFromJSONTyped(json, ignoreDiscriminator),
        'dailyRate': NewDailyRateFromJSON(json['dailyRate']),
    };
}

export function DailyRateFieldToJSON(value?: DailyRateField | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldToJSON(value, true),
        'dailyRate': NewDailyRateToJSON(value['dailyRate']),
    };
}

